module.exports = __webpack_public_path__ + "media/images/clock_fast-faf53ccf180478aad5a237d80b7326dc.png";